module.exports = __webpack_public_path__ + "images/emoji/ok_hand.8af248bf13441b70df76.png";